<section id="email-signature-container" class="center-75per-width mt-30">
    <div class="row">
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-6" *ngIf="emailSignatureList.length === 0">
                    <button class="btn blue-button" type="button" (click)="onAddSignatureOpen()"
                        id="add-button">{{'department-system.Add Signature' | translate | translateKey }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="email-signature-table mt-20">
        <div>
            <table class="table table-hover table-striped custab">
                <thead>
                    <tr>
                        <th class="pointer w-20">
                            {{'department-system.Operating Country' | translate |
                            translateKey }}
                        </th>
                        <th class="pointer w-60">{{'department-system.Signature' | translate |
                            translateKey }}
                        </th>
                        <th class="pointer w-20">{{'department-system.Actions' | translate | translateKey }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of emailSignatureList; let index = index;">
                        <td class="w-20">{{data.countryName}}</td>
                        <td *ngIf="editIndex !== index" class="break-space w-60"
                            [innerHtml]="data?.signature | safeHtml: false"></td>
                        <td *ngIf="editIndex === index" class="w-60">
                            <div class="ml-31">
                                <div id="content-editable-update" contenteditable="true"
                                    (keydown)="disableTextStyles($event);" [innerHtml]="editorData | safeHtml: false">
                                </div>
                            </div>
                            <div *ngIf="isRequired" class="alert-msg">
                                {{'department-system.Signature is required' | translate | translateKey }}
                            </div>
                        </td>
                        <td class="w-20">
                            <a *ngIf="editIndex !== index" (click)="editSignature(data?.signature, index)" title="{{'department-system.Edit' | translate |
                            translateKey }}">
                                <i class="fa fa-pencil font-18"></i>
                            </a>
                            <a *ngIf="editIndex === index" (click)="updateSignature(data?.isoCodeThree)" title="{{'department-system.Save' | translate |
                            translateKey }}">
                                <span><i *ngIf="isLoading" class="fa fa-spinner fa-spin"></i></span>
                                <span *ngIf="!isLoading"><i class="fa fa-check font-18"></i></span>
                            </a>
                            <a *ngIf="editIndex === index" (click)="closeEditor()" class="pl-10" title="{{'department-system.Cancel' | translate |
                            translateKey }}">
                                <span *ngIf="!isLoading"><i class="fa fa-close font-18"></i></span>
                            </a>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="emailSignatureList.length ===0">
                    <tr class="text-center w-100">
                        <td colspan="4">{{'department-system.No records found' | translate | translateKey }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <modal #addSignature [closeOnEscape]="false" [closeOnOutsideClick]="false" (onClose)="onAddSignatureClose()"
        class="add-signature">
        <modal-header>
            <h4 class="color-blue">{{'department-system.Add Signature' | translate | translateKey }}</h4>
        </modal-header>
        <modal-content>
            <div class="ml-31">
                <div id="content-editable-add" (keydown)="disableTextStyles($event);" contenteditable="true"
                    [innerHtml]="editorData"></div>
            </div>
            <div *ngIf="isRequired" class="alert-msg ml-10">
                {{'department-system.Signature is required' | translate | translateKey }}
            </div>
        </modal-content>
        <modal-footer>
            <div>
                <div class="text-right">
                    <button class="btn blue-button" type="button" (click)="onSaveAddSignature()" [disabled]="isLoading">
                        <span>{{'department-system.Save' | translate | translateKey }}
                            <i *ngIf="isLoading" class="fa fa-spinner fa-spin"></i>
                        </span>
                    </button>
                    <button class="btn grey-button" type="button" [disabled]="isLoading"
                        (click)="onAddSignatureClose()">{{'department-system.Close' |
                        translate |
                        translateKey }}</button>
                </div>
            </div>
        </modal-footer>
    </modal>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/email-signature.component.html